{
  "features": {
    "filePreview": {
      "measurements": {
        "label": "Målte figurer på denne siden",
        "show": "Vis målinger",
        "unlabelled": "Uten navn",
        "count": "{count, plural, one {# figur} other {# figurer}}",
        "measured": "Målt: {total}"
      }
    },
    "scopeBreakdown": {
      "title": "Omfangsoversikt",
      "frame": {
        "none": "Volve leser alle anbudsfilene inn i et ark etter din standard",
        "running": "Skriver omfangsoversikten",
        "failed": "Forrige kjøring mislyktes",
        "partial": "Delvis skrevet. Oppdater for å fullføre",
        "ready": "Omfangsoversikten etter din standard, som et ark",
        "unavailable": "Oppdateres"
      },
      "page": {
        "no-documents": {
          "title": "Ingen dokumenter å lese",
          "description": "Last opp anbudsdokumentene, eller prøv dem som ikke kunne analyseres på nytt.",
          "action": "Gå til filer"
        },
        "preparing": {
          "title": "Klargjør dokumentene",
          "description": "Du kan kjøre omfangsoversikten når anbudsdokumentene er analysert."
        },
        "empty": {
          "title": "Ingen omfangsoversikt ennå",
          "description": "Volve leser alle anbudsfilene og skriver omfangsoversikten som et ark, etter standarden du velger."
        },
        "running": {
          "title": "Starter kjøringen",
          "description": "Arket vises her når kjøringen oppretter det, og fylles etter hvert som Volve leser filene."
        },
        "unavailable": {
          "title": "Omfangsoversikten oppdateres",
          "description": "Den nye omfangsoversikten er ikke tilgjengelig ennå. Prøv igjen etter oppdateringen."
        },
        "failed": {
          "title": "Kunne ikke laste dokumentstatus",
          "description": "Prøv igjen for å sjekke om dokumentene er klare.",
          "action": "Prøv igjen"
        }
      },
      "runAlert": {
        "failed": {
          "title": "Forrige kjøring mislyktes",
          "run": "Arket fra kjøringen brukes ikke for arbeidspakker. Kjør på nytt for å starte forfra.",
          "update": "Arket beholder det oppdateringen skrev før den stoppet. Oppdater på nytt for å fortsette.",
          "reasons": {
            "time_limit": "Kjøringen nådde tidsgrensen før den skrev en rad.",
            "allowance": "Kjøringen brukte opp modellkallene sine før den skrev en rad.",
            "answer_refused": "Svaret fra kjøringen gjorde ikke rede for alle anbudsfilene, og den stoppet før den skrev en rad.",
            "agent_failed": "Agenten stoppet før den skrev en rad.",
            "no_standard": "Kjøringen angir ingen struktur. Velg en og kjør på nytt.",
            "expired": "Kjøringen sluttet å svare og ble avsluttet.",
            "crashed": "Kjøringen stoppet på grunn av en intern feil."
          }
        },
        "partial": {
          "title": "Forrige kjøring ble ikke ferdig med alt",
          "description": "{count, plural, =0 {Den stoppet før slutten. Oppdater fortsetter fra arket.} one {Den lot # fil være ulest. Oppdater leser den og fortsetter fra arket.} other {Den lot # filer være uleste. Oppdater leser dem og fortsetter fra arket.}}",
          "notRead": "Ikke lest"
        }
      },
      "run": {
        "run": "Kjør",
        "update": "Oppdater",
        "runDescription": "Volve leser alle anbudsfilene og skriver omfangsoversikten som et ark, i strukturen du velger. Kjøringen skjer i bakgrunnen, så du kan forlate siden.",
        "updateDescription": "Volve redigerer det gjeldende arket og beholder strukturen. Statuser, kommentarer, oppgaver og manuelle endringer blir stående. Bare filene som er lagt til siden forrige kjøring og filene som ble stående åpne, leses.",
        "startNew": "Start et nytt ark",
        "startNewDescription": "Det gjeldende arket, med statuser, kommentarer og oppgaver, blir liggende i biblioteket. Det nye arket erstatter det for arbeidspakker når kjøringen er ferdig.",
        "structure": "Struktur",
        "structures": {
          "library": {
            "title": "Standard fra biblioteket ditt",
            "description": "En standard i organisasjonens kunnskapsbaser, for eksempel en beskrivelsesstandard eller en målestandard. Volve leser også de andre standardene deres for de generelle delene den bygger på."
          },
          "volve": {
            "title": "Volve-arbeidspakker",
            "description": "Volves arbeidspakkemaler for prosjekttypen."
          },
          "template": {
            "title": "Din mal",
            "description": "Anbudsfiler som inneholder malen din, for eksempel et Excel-ark eller en PDF med et eksempel på oppsettet."
          },
          "tender_bill": {
            "title": "Anbudets egen beskrivelse",
            "description": "Byggherrens mengde- eller omfangsbeskrivelse: postene, kodene og rekkefølgen."
          }
        },
        "standards": "Standarder",
        "uploadStandard": "Last opp standard eller mal",
        "standardPreparing": "Klargjør standarden. Den velges automatisk når den er klar.",
        "standardFailed": "Standarden kunne ikke klargjøres. Prøv igjen eller fortsett uten den.",
        "retryStandard": "Prøv klargjøring på nytt",
        "skipStandard": "Fortsett uten denne standarden",
        "standardsDescription": "Velg en teknisk standard, et beskrivelsessystem, en håndbok eller en mal. Opplastinger lagres i biblioteket for gjenbruk.",
        "noStandards": "Ingen standarder er klare ennå. Last opp en standard eller mal for å komme i gang.",
        "instructions": "Instruksjoner",
        "instructionsPlaceholder": "f.eks. bare innvendige vegger; fyll mengder fra romskjemaene; én post per behandling",
        "instructionsUpdatePlaceholder": "f.eks. mål mengder for fanen Dører",
        "instructionsDescription": "Valgfritt. Volve følger dem i tillegg til strukturen.",
        "files": "Anbudsfiler",
        "noFiles": "Anbudet har ingen filer ennå. Last opp malen.",
        "upload": "Last opp",
        "pickStructure": "Velg en struktur",
        "pickStandard": "Velg minst én kunnskapsbase som inneholder standarden",
        "pickFiles": "Velg minst én anbudsfil til malen",
        "refused": {
          "preparing": "Anbudets dokumenter klargjøres fortsatt. Prøv igjen når de er klare.",
          "noDocuments": "Anbudet har ingen dokumenter ennå. Last dem opp først.",
          "noSheet": "Det finnes ikke noe ark å oppdatere. Start et nytt ark i stedet."
        },
        "genericError": "Det oppsto en feil, vennligst prøv igjen senere"
      },
      "outline": {
        "tree": "Koder",
        "search": "Søk kode eller tekst",
        "posts": "Poster",
        "postCount": "{count, plural, one {# post} other {# poster}}",
        "allPackages": "Alle pakker",
        "markers": {
          "inPackage": "I denne pakken",
          "input": "Trenger avklaring",
          "assumed": "Har antakelser",
          "interface": "Grensesnitt eller overlapp",
          "empty": "Tom kode",
          "orienting": "Orienterende tekst"
        },
        "states": {
          "stated": "Oppgitt i dokumentene",
          "assumed": "Antatt verdi",
          "input": "Trenger avklaring",
          "unsourced": "Ingen kilde"
        },
        "expand": "Utvid",
        "collapse": "Skjul",
        "noMatches": "Ingen koder eller rader passer",
        "empty": "Arket har ingen omfangsrader ennå",
        "openSource": "Åpne kilde",
        "assign": "Tildel",
        "move": "Flytt",
        "moveToCode": "Flytt til kode",
        "chapterEnd": "Kapittelet, nederst",
        "package": "Pakke",
        "discipline": "Fag",
        "exclude": "Ekskluder",
        "include": "Ta med igjen",
        "excluded": "Ekskludert",
        "task": "Oppgave",
        "quotePage": "s. {page}",
        "flagsAssumptions": "{count, plural, one {# antakelse} other {# antakelser}}",
        "flagsInputs": "{count, plural, one {# trenger avklaring} other {# trenger avklaring}}",
        "legendLines": "Rader",
        "noValue": "—",
        "sourceCount": "{count, plural, one {# kilde} other {# kilder}}",
        "assumed": "Antatt",
        "introduction": "Innledning",
        "orienting": {
          "label": "Orienterende tekst",
          "hint": "Anbudsvilkår som påvirker prisene under; prises ikke selv.",
          "more": "+{count}",
          "showAll": "Vis alle {count}",
          "showLess": "Vis færre",
          "add": "Legg til vilkår",
          "addPlaceholder": "Vilkåret, med anbudets ord",
          "addSave": "Legg til",
          "cancel": "Avbryt",
          "addedByYou": "Lagt til av deg",
          "comment": "Kommenter",
          "restore": "Gjenopprett",
          "marker": "{count, plural, one {# orienterende tekst} other {# orienterende tekster}}",
          "recheck": "Vilkår endret · Kontroller postene",
          "recheckIntro": "Den orienterende teksten under {heading} i fanen {tab} er endret. Kontroller postene under den, og juster omfang og mengder der endringen påvirker dem:",
          "changes": {
            "added": "Lagt til",
            "excluded": "Utelatt",
            "restored": "Gjenopprettet"
          }
        },
        "applies": {
          "label": "Gjelder her",
          "hint": "Arvet fra overskriftene over. Rediger ved overskriften.",
          "fromGroup": "fra {code} · denne gruppen",
          "fromTrade": "fra {code} · alle poster",
          "goToHeading": "Gå til overskriften",
          "showMore": "Vis {count} til",
          "showLess": "Vis færre"
        },
        "edit": {
          "confirm": "Bekreft",
          "edit": "Rediger",
          "save": "Lagre",
          "cancel": "Avbryt",
          "number": "Ikke et tall",
          "option": "Ikke et av valgene",
          "remeasure": "Mål posten på nytt",
          "remeasureInstruction": "Mål mengden for post {post} i fanen {tab} på nytt: {field} er nå {value}."
        },
        "suggestedChanges": "Foreslåtte endringer",
        "suggestedField": "Forslag til {field}",
        "clearSuggestedValue": "Tøm denne verdien",
        "acceptSuggestion": "Godta forslag",
        "dismissSuggestion": "Behold min verdi",
        "suggestionCount": "{count, plural, one {# foreslått endring} other {# foreslåtte endringer}}"
      },
      "openCurrentSheet": "Åpne gjeldende ark",
      "beta": "Beta"
    },
    "sheets": {
      "empty": "Arket har ingen faner ennå",
      "editorUnavailable": "Samtidig redigering er utilgjengelig. Viser siste lagrede versjon.",
      "review": "Vurdering",
      "inputErrors": {
        "number": "Skriv inn et tall",
        "option": "Velg et av kolonnens valg",
        "reference": "Referanser kommer fra agenten og kan ikke skrives inn"
      },
      "unknownDocument": "Dokument",
      "page": "Side {page}",
      "columnTypes": {
        "text": "Tekst",
        "number": "Tall",
        "enum": "Valg",
        "date": "Dato",
        "reference": "Referanse"
      },
      "save": "Lagre",
      "rowNumber": "Rad {number}",
      "undo": "Angre",
      "redo": "Gjør om",
      "download": "Last ned (.xlsx)",
      "downloadError": "Kunne ikke laste ned arket. Prøv igjen.",
      "tabFallback": "Fane {number}",
      "openRow": "Åpne raddetaljer og kommentarer",
      "editRefused": "Endringen ble ikke gjort",
      "unsavedRow": "Ikke lagret",
      "unsavedRowDescription": "Lagre nye rader før du vurderer dem eller oppretter oppgaver for dem",
      "saveRows": "Lagre {count, plural, one {ny rad} other {# nye rader}}",
      "saveError": "Kunne ikke lagre arket. Prøv igjen.",
      "sources": "Kilder",
      "sheetInScopeBreakdown": "Dette arket er omfangsoversikten",
      "sheetInScopeBreakdownDescription": "Se og rediger det i arbeidsområdets omfangsoversikt.",
      "openScopeBreakdown": "Åpne omfangsoversikt"
    }
  }
}
